<template>
  <nav
    aria-label="Breadcrumb"
    :class="[
      'flex w-full items-center text-size_3 font-bold capitalize',
      {
        'px-6 py-[35px] md:px-10 md:py-[60px]': background_image,
      },
    ]"
    :style="backgroundImageStyle"
  >
    <template v-for="(item, index) in visibleItems" :key="index">
      <NuxtLink
        v-if="index < visibleItems.length - 1"
        class="text-nowrap px-spacing_3 py-spacing_1 text-neutral-800 hover:text-primary-600"
        :class="[
          { truncate: item.truncate },
          background_image ? 'text-size_3 font-bold text-primary-100' : '',
        ]"
        :to="item.path"
      >
        {{ item.label }}
      </NuxtLink>
      <span
        v-else
        class="text-nowrap px-spacing_3 py-spacing_1 text-neutral-500"
        :class="[
          { truncate: item.truncate },
          background_image ? 'text-size_3 font-bold text-neutral-600' : '',
        ]"
      >
        {{ item.label }}
      </span>
      <span
        class="font-sans font-normal text-neutral-500 last:hidden odd:hidden"
      >
        /
      </span>
    </template>
  </nav>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    items: {
      label: string;
      path?: string;
      truncate?: boolean;
    }[];
    maxItems?: number;
    background_image?: string;
  }>(),
  {
    maxItems: 3,
  },
);

const visibleItems = computed(() => {
  if (props.items.length <= props.maxItems) return props.items;

  // Show first two and last two items, truncate middle items
  return [
    ...props.items.slice(0, 1),
    { label: "...", path: "" },
    ...props.items.slice(-2),
  ];
});

const backgroundImageStyle = computed(() => {
  return props.background_image
    ? {
        backgroundImage: `linear-gradient(90.02deg, rgba(11, 18, 4, 0.9) 0.03%, rgba(0, 0, 0, 0) 91.31%), url(${props.background_image})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }
    : {};
});
</script>
